import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { initAdminApi } from './api'
import { useSession } from './features/session/sessionStore'
import './styles/index.css'

/**
 * Indítás: előbb az API és a munkamenet, csak utána az útválasztó. A createBrowserRouter már
 * létrehozáskor lefuttatja a kezdő oldal védelmét, ezért az App modult a munkamenet betöltése után
 * importáljuk (különben újratöltéskor a belépő oldalra dobna).
 */
async function start() {
  const api = await initAdminApi()
  try {
    useSession.getState().setSession(await api.me())
  } catch {
    // A szerver nem érhető el: a belépő oldal jelenik meg, ott látszik a hiba
  }
  const { App } = await import('./App')
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
  // Fejlesztéshez és e2e tesztekhez: az API és a munkamenet elérhető a konzolból
  if (import.meta.env.DEV) {
    ;(window as unknown as Record<string, unknown>).__lolAdmin = { api, session: useSession }
  }
}

void start()
